import { render, staticRenderFns } from "./Eliminated.vue?vue&type=template&id=7517aafb&scoped=true&"
import script from "./Eliminated.vue?vue&type=script&lang=js&"
export * from "./Eliminated.vue?vue&type=script&lang=js&"
import style0 from "./Eliminated.vue?vue&type=style&index=0&id=7517aafb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517aafb",
  null
  
)

export default component.exports